import apiClient from 'api';
import { getQueryString } from 'api/utils';
import { RESOURCE_TYPES } from 'utils/appConstants';

const monitorApiBaseUrl = window.env.REACT_APP_MONITOR_API_PATH;

/**
 * Fetches all of the data for a particularly kind of resource from monitor server
 * @param {string} type - one of our resource types that monitor holds data for.
 * @param {Array} allowedParams - certain resources only allow for certain parameters.
 * @param {Object} queryParams - the parameters for this query.
 * @return {Object} response - holds the amount of responses and all the data.
 * @return {integer} response.all - total number of items in the data array.
 * @return {Array} response.data - an array of the response Object data
 */
export const fetchAllFromMonitorServer = async (
  type,
  allowedParams = ['start', 'limit'],
  queryParams = {}
) => {
  const typesAllowed = [
    'alarm',
    'aggregator',
    'control',
    'curve',
    'device',
    'indenode',
    'response',
    'toponode'
  ];
  if (typesAllowed.findIndex(typeAllowed => typeAllowed === type) === -1) {
    const errorMessage = 'Improper type fetched from monitor';
    throw new Error(errorMessage);
  }

  if (!queryParams.limit) {
    queryParams.limit = 100;
  }
  if (!queryParams.start) {
    queryParams.start = 0;
  }

  //Capitalization difference: While the API calls to /deras/toponode,
  //the results come back as results: [topoNodes: [...]]. The same applies for indeNodes.
  //The rest return as expected.
  let returnTypeSyntax = type;
  if (type === RESOURCE_TYPES.TOPONODE) {
    returnTypeSyntax = 'topoNode';
  } else if (type === RESOURCE_TYPES.INDENODE) {
    returnTypeSyntax = 'indeNode';
  }

  //Make the first query.
  const query = getQueryString(queryParams, allowedParams);
  let responses = await apiClient.get(monitorApiBaseUrl, `/${type}${query}`);

  if (type !== 'alarm') {
    while (responses.all > responses[`${returnTypeSyntax}s`].length) {
      queryParams.start = responses[`${returnTypeSyntax}s`].length;
      const newQuery = getQueryString(queryParams, allowedParams);
      const newResponse = await apiClient.get(
        monitorApiBaseUrl,
        `/${type}${newQuery}`
      );

      //Concat the responses.
      responses = {
        ...responses,
        [`${returnTypeSyntax}s`]: [
          ...responses[`${returnTypeSyntax}s`],
          ...newResponse[`${returnTypeSyntax}s`]
        ]
      };
    }
  }
  return responses[`${returnTypeSyntax}s`];
};
